const Fields = [
    {
        name: "ipType",
        label: "IP Type",
        toolTip: "IP connection type",
        type: "radio",
        editable: true,
        visible: true,
        options: [
            { label: "IPV4", value: "IPV4" },
            { label: "DUAL (IPV4 + IPV6)", value: "DUAL" }
        ],
    },
    {
        name: "domains",
        label: "Domain record",
        type: "array",
        toolTip: "Comma seperated list of domain record names to add",
        placeholder: "ex: aaa.example.com,bbb.example.com",
        editable: true,
        validation: [
            { type: "required" }
        ],
        visible: true,
    },
    {
        name: "fipsEnabled",
        label: "Enable FIPS",
        toolTip: "Use FIPS compliant certificate for domains",
        type: "checkbox",
        editable: true,
        visible: true,
        defaultValue:true
    },
    {
        name: "recordType",
        label: "Type",
        toolTip: "Type of Domain Record",
        type: "select",
        editable: true,
        validation: [
            { type: "required" }
        ],
        options:[
            { label: "CNAME", value: "CNAME" },
            { label: "Alias", value: "A" },
            { label: "Proxy", value: "PROXY" },
            { label: "FWD", value: "FWD" }
        ],
        visible: true,
    },
    {
        name: "proxyEnabled",
        label: "Proxy Enabled",
        toolTip: "Enable proxy support",
        type: "checkbox",
        editable: true,
        defaultValue: false,
        visible: true,
    }
];

export default Fields;